import { useCallback } from 'react';
import { ChangePersonalAddressEnum } from './ChangePersonalAddressSchema';
import { useChangePersonalAddress } from './useChangePersonalAddress';
import { useAccountSummaryQuery } from '../../../../hooks/query/useAccountSummaryQuery';
import { trackMixPanel } from '../../../../services/mixpanel.service';

interface IProps {
  getValues: any;
  onAddressUpdatedSuccessfully: any;
  handleErrorCode: any;
  customerId: string;
}

export const useHandleSucces = ({ onAddressUpdatedSuccessfully, getValues, handleErrorCode, customerId }: IProps) => {
  const { refetch: updateSummary, isRefetching } = useAccountSummaryQuery(() => {
    onAddressUpdatedSuccessfully();
  }, '', 'update_invalid_business_address');

  const handleSuccess = () => {
    trackMixPanel('Change RA address updated successfully');
    updateSummary();
  };

  const { isLoading, mutate: mutateChangeAddress } = useChangePersonalAddress(
    handleSuccess,
    handleErrorCode,
  );

  const handleConfirm = useCallback(() => {
    trackMixPanel('Change RA address submit clicked');
    mutateChangeAddress({
      street: getValues(ChangePersonalAddressEnum.street),
      apt: getValues(ChangePersonalAddressEnum.apt),
      city: getValues(ChangePersonalAddressEnum.city),
      state: getValues(ChangePersonalAddressEnum.state),
      zip: getValues(ChangePersonalAddressEnum.zip),
      customerId,
    });
  }, [getValues]);

  return { isLoading: isLoading || isRefetching, handleConfirm };
};
